// @ts-nocheck
export class SimpleByteRegister {
    offset;
    byteValue;
    constructor(offset) {
        this.byteValue = 0;
        this.offset = offset;
    }
    set value(newVal) {
        this.byteValue = newVal & 0xff;
    }
    get value() {
        return this.byteValue;
    }
}
//# sourceMappingURL=simple-byte-register.js.map